module.exports = __webpack_public_path__ + "img/duck-leg.ff3c9925.jpg";